module.exports = "https://www.gc-qa.gnp.com.mx/e692ce229e7c63ca189d6f125da48921.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/bg-video-5.png
// module id = 953
// module chunks = 0 1